"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Teaser_vue_1 = __importDefault(require("../Teaser.vue"));
const floating_vue_1 = require("floating-vue");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let RateCertificateItem = class RateCertificateItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.eventTracker = new EventTracker_1.default();
        this.colorController = new ColorLibController_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    eventTrackerRecommendationsPanel() {
        this.eventTracker.trackEvent('openRecommendationsPanel', true);
    }
    get description() {
        return this.colorController.getCategoryTitle(this.certification.category);
    }
    manageRecommendationDeployment() {
        if (this.forceDismiss) {
            this.$emit('onToggleRecommendations', false);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], RateCertificateItem.prototype, "isActive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], RateCertificateItem.prototype, "forceDismiss", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], RateCertificateItem.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], RateCertificateItem.prototype, "certification", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('forceDismiss')
], RateCertificateItem.prototype, "manageRecommendationDeployment", null);
RateCertificateItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Teaser: Teaser_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            ChevronRight: lucide_vue_next_1.ChevronRight,
            Dropdown: floating_vue_1.Dropdown,
            Info: lucide_vue_next_1.Info,
            GraphCertificateRate: bmk_ui_framework_1.GraphCertificateRate,
            ExternalLink: lucide_vue_next_1.ExternalLink
        },
    })
], RateCertificateItem);
exports.default = RateCertificateItem;
